import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";

import API from "../../Services/API";
import {toast} from "react-toastify";
import { useParams} from "react-router-dom";
import {HiOutlineLocationMarker, HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week} from "react-icons/bs";
import {TbArrowBadgeLeft, TbMoodEdit} from "react-icons/tb";
import { MdOutlineWorkOutline} from "react-icons/md";

import {GoStarFill} from "react-icons/go";
import {BiMessageRoundedEdit} from "react-icons/bi";


function RequestRate() {
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [request, setRequest] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [comment, setComment] = React.useState('');
    const [loading, setLoading] = React.useState('d-none');
    const [buttonStatus, setButtonStatus] = React.useState( "");
    const [buttonText, setButtonText] = React.useState('ثبت نظر');


    React.useEffect(() => {
        const search = window.location.search;
        const query = new URLSearchParams(search);
        const message = query.get('message')
        if(message) {
            const success = query.get('success')
            success === '1' ? toast.success(message) : toast.error(message)
        }

        const params = {
            'processFor' : 'Customer'
        }

        API.getRequest(params , id)
            .then((response) => {
                setRequest(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                    window.history.back()
                }
                else {
                    toast.error(error.message);
                    window.history.back()
                }
            });


    }, [id]);



    const onButtonClick =  () => {
        if (score < 1) {
            toast.warning('لطفا امتیاز را مشخص کنید')
            return false;
        }
        if (comment.length < 3) {
            toast.warning('لطفا نطر خود را وارد کنید')
            return false;
        }
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");
        const request = {
            request_id : id,
            rate : score,
            comment : comment,
        }

        API.saveRate(request)
            .then((response) => {
                toast.success(response.message);
                setTimeout (() => {
                    window.location.replace(`/requests/${response.data.id}`);
                },1500)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }

            <Header title='مشاهده درخواست' hasBack={true}  />

            {
                isLoaded &&
                <section className="container-fluid  mt-3 py-5 rtl px-0   ">
                    <div className="row mx-2 mb-3 border-bottom pb-2">


                        <div className="col-1">
                            <HiOutlineQrcode />
                        </div>
                        <div className="col-5 text-small-2">
                            شماره قبض
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.tracking_code}
                        </div>
                    </div>


                    <div className="row mx-2 mb-3  pb-2">
                        <div className="col-1 ">
                            <BsCalendar4Week />
                        </div>
                        <div className="col-4 text-small-2">
                            تاریخ ثبت
                        </div>
                        <div className="col-7 text-start fw-bold text-small-2">
                            {request.date}
                        </div>
                    </div>


                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <HiOutlineLocationMarker />
                        </div>
                        <div className="col-11 text-small-2 pt-1">
                            <b>{request.address.title}</b> :&nbsp;
                            {request.address.address}
                        </div>

                    </div>
                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <MdOutlineWorkOutline />
                        </div>
                        <div className="col-11 text-small-2 pt-1">
                            <b>{request.company.title}</b>
                        </div>

                    </div>

                    <div className="row bg-secondary-subtle mt-4 p-3">
                        <div className="col-12 px-4 fw-bold">
                            <TbMoodEdit className='ms-2' />
                            ثبت امتیاز برای درخواست
                        </div>
                        <div className="col-12 text-center mt-4">
                            <span>
                                <GoStarFill className={score > 0 ? 'text-big-5 mx-2 text-warning' :  'text-big-5 mx-2 text-dark opacity-50'} onClick={() => {setScore(1)}} />
                            </span>
                            <span>
                                <GoStarFill className={score > 1 ? 'text-big-5 mx-2 text-warning' :  'text-big-5 mx-2 text-dark opacity-50'} onClick={() => {setScore(2)}} />
                            </span>
                            <span>
                                <GoStarFill className={score > 2 ? 'text-big-5 mx-2 text-warning' :  'text-big-5 mx-2 text-dark opacity-50'} onClick={() => {setScore(3)}} />
                            </span>
                            <span>
                                <GoStarFill className={score > 3 ? 'text-big-5 mx-2 text-warning' :  'text-big-5 mx-2 text-dark opacity-50'} onClick={() => {setScore(4)}} />
                            </span>
                            <span>
                                <GoStarFill className={score > 4 ? 'text-big-5 mx-2 text-warning' :  'text-big-5 mx-2 text-dark opacity-50'} onClick={() => {setScore(5)}} />
                            </span>

                        </div>
                        <div className="col-12 text-center fw-bold text-primary-color mt-3">
                            {
                                score === 0 ? '-' : (score === 1 ? 'ضعیف (۱)' : (score === 2 ? 'تقریبا ضعیف (۲)' : (score === 3 ? 'متوسط (۳)' : (score === 4 ? 'خوب (۴)' : 'عالی (۵)')) ))
                            }
                        </div>

                    </div>
                    <div className="row bg-secondary-subtle mt-4 p-3">
                        <div className="col-12 fw-bold px-4">
                            <BiMessageRoundedEdit className='ms-2' />
                            ثبت نظر برای درخواست
                        </div>
                        <div className="col-12 mt-3">
                            <textarea id=""  rows="5" className='rounded w-100 p-2 text-big-2'
                            onChange={(val) => {setComment(val.target.value)}}
                                      value={comment}
                            ></textarea>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-2 fixed-bottom max-w-lg">

                            <button
                                className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                                onClick={onButtonClick}
                                disabled={buttonStatus}
                            >
                                {buttonText}
                                <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                                <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                       aria-hidden="true">

                            </span>
                            </button>
                        </div>
                    </div>

                </section>
            }


        </React.Fragment>
    );
}

export default RequestRate;